import sidebar from '@/router/lang/sidebar';
import { merge } from 'lodash';
const breadCrumb = {
    'en-us': {
        accountCreate: 'Create',
        accountEdit: 'Account Edit',
        roleEdit: 'Roles Edit',
        roleCreate: 'Create Role',
        createTask: 'Create Task',
        createCrowdCountingTask: 'Create Crowd Counting Task',
        createStaffDutyleaveTask: 'Create Unauthorized Leave Task',
        createQueueTask: 'Create Queue Management Task',
        editTask: 'Edit Task',
        detailStaffDutyleaveTask: 'Unauthorized Leave Task',
        detailCrowdCounting: 'Crowd Counting Task',
        editCrowdCountingTask: 'Edit Crowd Counting Task',
        editStaffDutyleaveTask: 'Edit Unauthorized Leave Task',
        editQueueTask: 'Edit Queue Management Task',
        createPortrait: 'Create Portrait',
        editPortrait: 'Edit Portrait',
        createPortraitLibrary: 'Create Portrait Library',
        editPortraitLibrary: 'Edit Portrait Library',
        settings: 'Settings',
        createVirtual: 'New Virtual Zone',
        editVirtual: 'Edit Virtual Zone',
        otauploadedit: 'OTA Upload',
        createWhiteGroup: 'Create Allowlist Group',
        createBlackGroup: 'Create Blocklist Group',
        editBlackGroup: 'Edit Bloclist Group',
        createBlack: 'Create Blocklist Member',
        editBlack: 'Edit Blocklist Member',
        createWhite: 'Create Allowlist Memeber',
        editWhite: 'Edit Allowlist Memeber',
        editWhiteGroup: 'Edit Allowlist Group',
        createVisitorGroup: 'Create VisitorGroup',
        editVisitorGroup: 'Edit VisitorGroup',
        createVisitor: 'Create Visitor',
        editVisitor: 'Edit Visitor',
        bulkPhoto: 'Bulk Photo',
        editPassSchedule: 'Edit Pass Schedule',
        createPassSchedule: 'Create Pass Schedule',
        statusDetail: 'Status Detail',
        backgroundManagement: 'Background Management',
        qrAccess: 'QR Access',
        basemap: 'Map Creation',
        mapManagement: 'Map Configuration',
        addBasemap: 'Basemap',
        taskList: 'Task Monitor',
        spacemanagement: 'Zone Configuration',
        renderkanban: 'Zone Definition',
        editSpace: 'Edit',
        addSpace: 'Create',
        createFR: 'Create Task-Face Recognition',
        editFR: 'Edit Task-Face Recognition',
        trajectoryTrackingList: 'Profile Search',
        trajectoryMap: 'Trajectory Tracking Result',
        application: 'Application',
        crowdDensity: 'Create Crowd Density Task',
        crowdAndIndividual: 'Crowd and Individual',
        lookCrowdStatistic: 'Crowd Counting Task',
        createCrowdStatistic: 'Create Crowd Counting Task',
        editCrowdStatistic: 'Edit Crowd Counting Task',
        lookOffDutyDetection: 'Staff Duty leave Task',
        createOffDutyDetection: 'Create Staff Duty leave Task',
        editOffDutyDetection: 'Edit Staff Duty leave Task',
        lookQueue: 'Queue Task',
        createQueue: 'Create Queue Task',
        editQueue: 'Edit Queue Task',
        lookCrowdDensity: 'Crowd Density Task',
        createCrowdDensity: 'Create Crowd Density Task',
        editCrowdDensity: 'Edit Crowd Density Task',
        lookCrowdRetrograde: 'Crowd Counterflow Task',
        createCrowdRetrograde: 'Create Crowd Counterflow Task',
        editCrowdRetrograde: 'Edit Crowd Counterflow Task',
        lookCrowdIntrusion: 'Crowd Intrusion Task',
        createCrowdIntrusion: 'Create Crowd Intrusion Task',
        editCrowdIntrusion: 'Edit Crowd Intrusion Task',
        lookCrowdStrand: 'Crowd Retention Task',
        createCrowdStrand: 'Create Crowd Retention Task',
        editCrowdStrand: 'Edit Crowd Retention Task',
        lookCrowdSocialDistance: 'Close Social Distance Task',
        createCrowdSocialDistance: 'Create Close Social Distance Task',
        editCrowdSocialDistance: 'Edit Close Social Distance Task',
        lookCrowdCongregate: 'Crowd Gather and Dispersion Task',
        createCrowdCongregate: 'Create Crowd Gather and Dispersion Task',
        editCrowdCongregate: 'Edit Crowd Gather and Dispersion Task',
        face: 'Face',
        lookFaceAlert: 'Face Comparison Task',
        createFaceAlert: 'Create Face Comparison Task',
        editFaceAlert: 'Edit Face Comparison Task',
        lookFaceAttribute: 'Face Attribute Recognition Task',
        createFaceAttribute: 'Create Face Attribute Recognition Task',
        editFaceAttribute: 'Edit Face Attribute Recognition Task',
        lookFacePedestrianAlert: 'Face&Body Recognition Task',
        createFacePedestrianAlert: 'Create Face&Body Recognition Task',
        editFacePedestrianAlert: 'Edit Face&Body Recognition Task',
        body: 'Body',
        lookPedestrianAttribute: 'Body Attribute Recognition Task',
        createPedestrianAttribute: 'Create Body Attribute Recognition Task',
        editPedestrianAttribute: 'Edit Body Attribute Recognition Task',
        vehicle: 'Vehicle',
        lookAutomobileAttribute: 'Vehicle Attribute Recognition Task',
        createAutomobileAttribute: 'Create Vehicle Attribute Recognition Task',
        editAutomobileAttribute: 'Edit Vehicle Attribute Recognition Task',
        createRoadDefectionDetect: 'Create Road Detection Task',
        editRoadDefectionDetect: 'Edit Road Detection Task',
        lookRoadDefectionDetect: 'Road Detection Task',
        createTrashDetect: 'Create Waste Detection Task',
        editTrashDetect: 'Edit  Waste Detection Task',
        lookTrashDetect: 'Waste Detection Task',
        createKitchenStaffDetect: 'Create Anomaly Task',
        editKitchenStaffDetect: 'Edit Anomaly Task',
        lookKitchenStaffDetect: 'Anomaly Task',
        createCrowdCrossLineStatistic: 'Create Crowd Counting(Crossline) Task',
        lookCrowdCrossLineStatistic: 'Crowd Counting(Crossline) Task',
        editCrowdCrossLineStatistic: 'Edit Crowd Counting(Crossline) Task',
        createCrossLineAlertDetect: 'Create Crowd Crossline Task',
        lookCrossLineAlertDetect: 'Crowd Crossline Task',
        editCrossLineAlertDetect: 'Edit Crowd Crossline Task',
        createAbnormalBehaviorDetect: 'Create Abnormal Behavior Task',
        editAbnormalBehaviorDetect: 'Edit Abnormal Behavior Task',
        lookAbnormalBehaviorDetect: 'Abnormal Behavior Task',
        createFireDetectionDetect: 'Create Fire Detection Task',
        editFireDetectionDetect: 'Edit Fire Detection Task',
        lookFireDetectionDetect: 'Fire Detection Task',
        createTrafficRetrogradeDetect: 'Create Counterflow Driving Task',
        createTrafficViolationDetect: 'Create Illegal Parking Task',
        createNoneMotorVehiclePedestrianDetect: 'Create Non-motor Vehicle and Pedestrian Intrusion Task',
        createTrafficCongestionDetect: 'Create Congestion Task',
        createVirtualZoneStatistic: 'Create Crowd Counting(VA) Task',
        editVirtualZoneStatistic: 'Edit Crowd Counting(VA) Task',
        lookVirtualZoneStatistic: 'Crowd Counting(VA) Task',
        lookTrafficViolationDetect: 'Illegal Parking Task',
        lookNoneMotorVehiclePedestrianDetect: 'Non-motor Vehicle and Pedestrian Intrusion Task',
        lookTrafficCongestionDetect: 'Congestion Task',
        editTrafficViolationDetect: 'Edit Illegal Parking Task',
        editNoneMotorVehiclePedestrianDetect: 'Edit Non-motor Vehicle and Pedestrian Intrusion Task',
        editTrafficCongestionDetect: 'Edit Congestion Task',
        deviceManagementPassDetail: 'Device Management Detail',
        deviceManagementPassBackground: 'Device Management Background',
        backgroundManagementDetail: 'Edit Background Management',
        backgroundManagementCreat: 'Create Background Management',
        otaDetail: 'Ota Detail',
        otaCreate: 'Ota Create',
        editOta: 'Ota Edit',
        otaUpload: 'Update Package Upload',
        lookTrafficRetrogradeDetect: 'Counterflow Driving Task',
        editTrafficRetrogradeDetect: 'Edit Counterflow Driving Task',
        createClusterStatistic: 'Create File Cluster Task',
        editClusterStatistic: 'Edit File Cluster Task',
        createBigData: 'Create Frequency Analysis Task',
        editBigData: 'Edit Frequency Analysis Task',
        lookRealtimeCluster: 'File Cluster Task',
        lookBigData: 'Frequency Analysis Task',
        clusterResult: 'File Cluster Result',
        bigDataResult: 'Frequency Analysis Result',
        bigDataDetail: 'Result Details',
        fileDetail: 'File Details',
        snapRecord: 'Snap Record',
        taskResult: 'Task Result',
        createPedestrianCrossLine: 'Create Body Attribute Recognition(Crossline) Task',
        lookPedestrianCrossLine: 'Body Attribute Recognition(Crossline) Task',
        editPedestrianCrossLine: 'Edit Body Attribute Recognition(Crossline) Task',
        newPortrait: 'New Portrait',
        newBody: 'New Body',
        portraitDetails: 'Portrait Details',
        newVehicle: 'New Vehicle',
        editVehicle: 'Edit Vehicle',
        portraitImport: 'Batch Import',
        vehicleImport: 'Batch Import',
        portraitRecords: 'Batch Import Record Details',
        vehicleRecords: 'Batch Import Record Details',
        createUnidentifiedObjectRetentionDetect: 'Create Unidentified Object Retention Detection Task',
        lookUnidentifiedObjectRetentionDetect: 'Unidentified Object Retention Detection Task',
        editUnidentifiedObjectRetentionDetect: 'Edit Unidentified Object Retention Detection Task',
        createHumanPoweredVehicleDetect: 'Create Non-Motor Vehicle Attribute Recognition Task',
        lookHumanPoweredVehicleDetect: 'Non-Motor Vehicle Attribute Recognition Task',
        editHumanPoweredVehicleDetect: 'Edit Non-Motor Vehicle Attribute Recognition Task',
        createEverythingDetect: 'Create Analysis of Everything',
        editEverythingDetect: 'Edit Analysis of Everything',
        lookEverythingDetect: 'Look Analysis of Everything',
    },
    zh: {
        deviceManagementPassDetail: '设备详情',
        deviceManagementPassBackground: '设备背景图管理',
        backgroundManagementDetail: '背景图编辑',
        backgroundManagementCreat: '创建背景图',
        otaDetail: 'Ota详情',
        otaCreate: 'Ota创建',
        editOta: 'Ota编辑',
        otaUpload: '更新包上传',
        accountCreate: '新增账户',
        accountEdit: '编辑账号',
        roleEdit: '角色编辑',
        roleCreate: '创建角色',
        createTask: '新建任务',
        createCrowdCountingTask: '新建人群统计任务',
        detailCrowdCounting: '人群统计任务',
        detailStaffDutyleaveTask: '人员离岗任务',
        createStaffDutyleaveTask: '新建人员离岗任务',
        createQueueTask: '新建排队管理任务',
        editTask: '编辑任务',
        editCrowdCountingTask: '编辑人群统计任务',
        editStaffDutyleaveTask: '编辑人员离岗任务',
        editQueueTask: '编辑排队管理任务',
        createPortrait: '新建人像',
        editPortrait: '修改人像',
        createPortraitLibrary: '新建人像库',
        editPortraitLibrary: '修改人像库',
        settings: '系统管理',
        createVirtual: '新增虚拟区域',
        editVirtual: '编辑虚拟区域',
        editQueueControl: '编辑排队任务',
        otauploadedit: '上传更新包',
        createWhiteGroup: '创建白名单组',
        createBlackGroup: '创建黑名单组',
        editBlackGroup: '编辑黑名单组',
        createBlack: '创建黑名单人员',
        editBlack: '编辑黑名单人员',
        createWhite: '创建白名单人员',
        editWhite: '编辑白名单人员',
        editWhiteGroup: '编辑白名单组',
        createVisitorGroup: '创建访客组',
        editVisitorGroup: '编辑访客组',
        createVisitor: '创建访客',
        editVisitor: '编辑访客',
        bulkPhoto: '入库图',
        editPassSchedule: '编辑通行时刻表',
        createPassSchedule: '创建通行时刻表',
        statusDetail: '状态详情',
        backgroundManagement: '背景图管理',
        qrAccess: '二维码通行',
        basemap: '底图管理',
        mapManagement: '地图管理',
        addBasemap: '添加底图',
        taskList: '任务列表',
        addTask: '任务添加',
        renderkanban: '渲染看板',
        spacemanagement: '空间管理',
        editSpace: '编辑空间',
        addSpace: '新增空间',
        createFR: '新建任务-人脸识别',
        editFR: '编辑任务-人脸识别',
        trajectoryTrackingList: '人档检索',
        trajectoryMap: '轨迹追踪结果',
        application: '场景化应用',
        crowdDensity: '创建人群密度任务',
        crowdAndIndividual: '人群任务',
        lookCrowdStatistic: '人群任务',
        createCrowdStatistic: '创建人群任务',
        editCrowdStatistic: '编辑人群任务',
        lookOffDutyDetection: '离岗任务',
        createOffDutyDetection: '创建离岗任务',
        editOffDutyDetection: '编辑离岗任务',
        lookQueue: '排队任务',
        createQueue: '创建排队任务',
        editQueue: '编辑排队任务',
        lookCrowdDensity: '人群密度任务',
        createCrowdDensity: '创建人群密度任务',
        editCrowdDensity: '编辑人群密度任务',
        lookCrowdRetrograde: '人群逆流任务',
        createCrowdRetrograde: '创建人群逆流任务',
        editCrowdRetrograde: '编辑人群逆流任务',
        lookCrowdIntrusion: '人群入侵任务',
        createCrowdIntrusion: '创建人群入侵任务',
        editCrowdIntrusion: '编辑人群入侵任务',
        lookCrowdStrand: '人群滞留任务',
        createCrowdStrand: '创建人群滞留任务',
        editCrowdStrand: '编辑人群滞留任务',
        lookCrowdSocialDistance: '社交距离任务',
        createCrowdSocialDistance: '创建社交距离任务',
        editCrowdSocialDistance: '编辑社交距离任务',
        lookCrowdCongregate: '人群聚集分散任务',
        createCrowdCongregate: '创建人群聚集分散任务',
        editCrowdCongregate: '编辑人群聚集分散任务',
        face: '人脸任务',
        lookFaceAlert: '人脸比对任务',
        createFaceAlert: '创建人脸比对任务',
        editFaceAlert: '编辑人脸比对任务',
        lookFaceAttribute: '人脸属性识别任务',
        createFaceAttribute: '创建人脸属性识别任务',
        editFaceAttribute: '编辑人脸属性识别任务',
        looFacePedestrianAlert: '人脸&人体联合任务',
        createFacePedestrianAlert: '创建人脸&人体联合任务',
        editFacePedestrianAlert: '编辑人脸&人体联合任务',
        body: '人体任务',
        lookPedestrianAttribute: '人体属性识别任务',
        createPedestrianAttribute: '创建人体属性识别任务',
        editPedestrianAttribute: '编辑人体属性识别任务',
        vehicle: '车辆任务',
        lookAutomobileAttribute: '车辆属性识别任务',
        createAutomobileAttribute: '创建车辆属性识别任务',
        editAutomobileAttribute: '编辑车辆属性识别任务',
        createRoadDefectionDetect: '创建路面缺陷检测任务',
        editRoadDefectionDetect: '编辑道路检测任务',
        lookRoadDefectionDetect: '道路检测任务',
        createTrashDetect: '创建垃圾检测任务',
        editTrashDetect: '编辑垃圾检测任务',
        lookTrashDetect: '垃圾检测任务',
        createKitchenStaffDetect: '创建厨房规范行为任务',
        editKitchenStaffDetect: '编辑厨房规范行为任务',
        lookKitchenStaffDetect: '厨房规范行为任务',
        createCrowdCrossLineStatistic: '创建人群统计跨线任务',
        lookCrowdCrossLineStatistic: '人群跨线统计任务',
        editCrowdCrossLineStatistic: '编辑人群跨线统计任务',
        createCrossLineAlertDetect: '创建人群跨线任务',
        lookCrossLineAlertDetect: '人群跨线任务',
        editCrossLineAlertDetect: '编辑人群跨线任务',
        createAbnormalBehaviorDetect: '创建异常行为检测任务',
        editAbnormalBehaviorDetect: '编辑异常行为检测任务',
        lookAbnormalBehaviorDetect: '异常行为检测任务',
        createFireDetectionDetect: '创建烟火检测任务',
        editFireDetectionDetect: '编辑烟火检测任务',
        lookFireDetectionDetect: '烟火检测任务',
        lookNoneMotorVehiclePedestrianDetect: '交通（非机动车行人入侵）检测任务',
        lookTrafficJamDetect: '交通拥堵检测任务',
        editNoneMotorVehiclePedestrianDetect: '编辑交通（非机动车行人入侵）检测任务',
        editTrafficJamDetect: '编辑交通拥堵检测任务',
        createTrafficRetrogradeDetect: '创建逆行检测任务',
        createTrafficViolationDetect: '创建违停检测任务',
        createNoneMotorVehiclePedestrianDetect: '创建交通（非机动车行人入侵）检测任务',
        createTrafficCongestionDetect: '创建交通拥堵检测任务',
        editTrafficCongestionDetect: '编辑交通拥堵检测任务',
        lookTrafficCongestionDetect: '交通拥堵检测任务',
        createVirtualZoneStatistic: '创建人群计数（虚拟区域）任务',
        editVirtualZoneStatistic: '编辑人群计数（虚拟区域）任务',
        lookVirtualZoneStatistic: '人群计数（虚拟区域）任务',
        lookTrafficViolationDetect: '违停检测任务',
        editTrafficViolationDetect: '编辑违停检测任务',
        lookTrafficRetrogradeDetect: '逆行检测任务',
        editTrafficRetrogradeDetect: '编辑逆行检测任务',
        createClusterStatistic: '创建聚档任务',
        createBigData: '创建频率分析任务',
        editClusterStatistic: '编辑人像聚档任务',
        editBigData: '编辑频率分析任务',
        lookRealtimeCluster: '查看人像聚档任务',
        lookBigData: '查看频率分析任务',
        clusterResult: '查看人像聚档结果',
        bigDataResult: '查看频率分析结果',
        bigDataDetail: '结果详情',
        fileDetail: '档案详情',
        snapRecord: '抓拍记录',
        taskResult: '任务结果',
        createPedestrianCrossLine: '创建人体属性识别（跨线）任务',
        lookPedestrianCrossLine: '人体属性识别（跨线）任务',
        editPedestrianCrossLine: '编辑人体属性识别（跨线）任务',
        newPortrait: '新建人像',
        newBody: '新建人体',
        portraitDetails: '人像详情',
        newVehicle: '新建车辆',
        editVehicle: '编辑车辆',
        portraitImport: '批量导入',
        vehicleImport: '批量导入',
        portraitRecords: '批量导入记录详细信息',
        vehicleRecords: '批量导入记录详细信息',
        createUnidentifiedObjectRetentionDetect: '创建不明物体滞留检测任务',
        lookUnidentifiedObjectRetentionDetect: '不明物体滞留检测任务',
        editUnidentifiedObjectRetentionDetect: '编辑不明物体滞留检测任务',
        createHumanPoweredVehicleDetect: '创建非机动车属性识别任务',
        lookHumanPoweredVehicleDetect: '非机动车属性识别任务',
        editHumanPoweredVehicleDetect: '编辑非机动车属性识别任务',
        createEverythingDetect: '创建万物解析任务',
        editEverythingDetect: '编辑万物解析任务',
        lookEverythingDetect: '查看万物解析任务',
    },
};
export default merge({}, breadCrumb, sidebar);
